import React from 'react';

const Contact = () => {
  return (
    <div className="prose prose-gray max-w-none">
      <p className="text-gray-600 leading-relaxed">
        For any questions about this privacy policy or our privacy practices, please contact us at privacy@somatopia.com
      </p>
    </div>
  );
};

export default Contact;